/**
 * Which EXPERIENCE of the app a person gets (client experience, decision D1): what the Home shows and which internal chrome (Ask Bob, New Project) is offered.
 * The experience no longer decides the NAVIGATION: which menus, submenus, tabs and routes a person opens is the navigation matrix of their ROLE in the active company
 * (contexts/NavigationContext.tsx, lib/navigation-catalog.ts, table nav_visibility). Permissions, project membership, assignment, the API and RLS decide the real access.
 * Hiding a menu is not security: the server refuses the same requests whatever the screen shows.
 *
 *   internal  a company's own people and vendors (the full Home)
 *   client    a client account: a Home without internal figures
 *   pending   the account type is not known yet (or could not be read): the client-safe Home. Nothing internal is shown "just in case".
 */
import type { AccountType } from '@/contexts/UserContext';

export type Experience = 'internal' | 'client' | 'pending';

export function resolveExperience({ accountType, accountTypeResolved, userRole }: { accountType: AccountType | null; accountTypeResolved: boolean; userRole: string | null }): Experience {
  if (accountType === 'client_account') return 'client';
  if (!accountTypeResolved) return userRole === 'client' ? 'client' : 'pending'; // a client is never shown the internal app while the account type is on its way
  if (accountType === null && userRole === 'client') return 'client'; // an unclassified account that is a client of its company
  return 'internal';
}

/** Internal-only chrome (the Ask Bob button, New Project): shown to internal people only. */
export function showsInternalChrome(experience: Experience): boolean {
  return experience === 'internal';
}
